<template>
    <div class="part">
        <p>{{ $t("Save more with best fit box!") }}</p>
        <span>
            {{
                $t(
                    "FitBox Lorem ipsum dolor sit amet, consectetur adipiscing elit."
                )
            }}
        </span>
        <div class="center-text">
            <button class="button is-primary" @click="setAction">
                {{ $t("More details") }}
            </button>
        </div>
    </div>
</template>

<script>
export default {
    methods: {
        setAction() {
            this.$buefy.toast.open({
                message: this.$t("Coming Soon!"),
                type: "is-primary",
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.part {
    width: 100%;
    height: 100%;

    &:lang(ar) {
        text-align: right;
    }

    p {
        font-weight: bold;
        font-size: 2.4rem;
        line-height: 1.2;
        margin-bottom: 40px;
    }

    span {
        display: inline-block;
        margin-bottom: 40px;
    }

    .center-text {
        text-align: center;
    }
}
</style>
